module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-time-out-forklift/master-time-out-forklift.component.scss
// module id = ./src/app/master/master-time-out-forklift/master-time-out-forklift.component.scss
// module chunks = main